<template>
  <div class="teste">
    <b-card no-body >
      <b-card-header header-tag="header" class="d-flex align-items-center w-100 h-100 p-0" role="tab">
        <div v-on:click="changeAngel = !changeAngel" v-b-toggle="i.toString()" variant="info" class="head-mes justify-content-between w-100">
          <div class="title-left pl-3">
            <div class="title-colapse-table">{{data.nome}} - <span style="color:grey;">{{data.suites + ' Suítes / ' + data.metragem + ' M²'}}</span></div>
          </div>
          <div class="d-flex align-items-center">
            <div class="componente">
              <button class="buttonImage">
                <div class="opentable" >
                  <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
                  <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="icons-Popup d-flex ml-2 mr-3">
          <i class="fas fa-vr-cardboard mr-3" style="cursor:pointer; scale:1.5;" v-on:click="$emit('openLinkVirtual', data.id)" ></i>
          <i class="fas fa-images mr-3" style="cursor:pointer;  scale:1.5;" v-on:click="$emit('openUS', data.id)" ></i>
        </div>
      </b-card-header>
      <b-collapse :id="i.toString()" :accordion="i.toString()" role="tabpanel">
        <b-card-body>
          <div id="overflowtable" v-if="tipo == 0">
            <table class="table table-hover">
                <thead class="thead-default" style="background-color: #008148;color: white">
                    <tr>
                    <th class="text-center"><span>TORRE</span></th>
                    <th class="text-center"><span>ANDAR</span></th>
                    <th class="text-center"><span>APARTAMENTO</span></th>
                    <th class="text-center"><span>SOL</span></th>
                    <th class="text-center"><span>VALOR TOTAL</span></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="dataCol in data.lstREEmpreendimentoUnidadePreco" v-bind:key="dataCol.id">
                      <td class="text-center">{{dataCol.grupo}}</td>
                      <td class="text-center">{{dataCol.localidade}}</td>
                      <td class="text-center">{{dataCol.unidade}}</td>
                      <td class="text-center">{{dataCol.posicao ==  0 ? 'Sol da Manhã' : 'Sol da Tarde'}}</td>
                      <td class="text-center">{{dataCol.valorTotalFormatado}}</td>
                    </tr>
                    <tr v-if="data.lstREEmpreendimentoUnidadePreco.length == 0">
                      <td colspan="5" class="text-center">Sem dados</td>
                    </tr>
                </tbody>
            </table>
          </div>
          <div id="overflowtable" v-if="tipo == 1">
            <table class="table table-hover">
                <thead class="thead-default" style="background-color: #008148;color: white">
                    <tr>
                    <th class="text-center"><span>LOTE</span></th>
                    <th class="text-center"><span>QUADRA</span></th>
                    <th class="text-center"><span>SOL</span></th>
                    <th class="text-center"><span>VALOR TOTAL</span></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="dataCol in data.lstREEmpreendimentoUnidadePreco" v-bind:key="dataCol.id">
                      <td class="text-center">{{dataCol.grupo}}</td>
                      <td class="text-center">{{dataCol.unidade}}</td>
                      <td class="text-center">{{dataCol.posicao ==  0 ? 'Sol da Manhã' : 'Sol da Tarde'}}</td>
                      <td class="text-center">{{dataCol.valorTotalFormatado}}</td>
                    </tr>
                    <tr v-if="data.lstREEmpreendimentoUnidadePreco.length == 0">
                      <td colspan="5" class="text-center">Sem dados</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import Tablepriceacording from './tablepriceacording'
export default Tablepriceacording
</script>

<style scoped>

.icons-Popup {
  z-index: 10;
}
.teste {
  position: relative;
}
.buttonImage {
  z-index: 0;
  color: black;
  border: none;
  width: 100%;
  font-weight: bold;
  height: 100%;
  font-size: 17px;
}
#overflowtable {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 300px;
}
.arrow-angel{
  font-size: 30px;
  color: black;
}
.componente{
  display: flex;
  font-size: 18px;
  color: black;
  align-items: center;
}
.title-colapse-table{
    color: #008148;
    font-size: 20px;
    font-weight: bold;
    font-family:'Segoe UI'
}
.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.head-mes{
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/tablepriceacording/tablepriceacording.vue